export default __webpack_public_path__ + "static/media/51.c3491ad7.png";